define('models/CartProductModel',['underscore', 'ObjectModel', 'LocalStorage', 'app', 'UrlFactory', 'models/ProductModel', 'formatPrice', 'sprintf'], function (_, ObjectModel, LocalStorage, app, UrlFactory, ProductModel, formatPrice, sprintf) {
    //
    // Model CartProduct
    //
    var CartProductModelPrototype = {

        name:'CartProductModel',
        idAttribute:'id_cart_product',
        route:'apiCartProductModel',

        defaults:{
            type:'default',
            sync:true,
            deleted:false
        },

        initialize:function(options,collection){

            var model = this, product, cart = model.attributes.cart;
            // attribution automatique du type à partir de celui de la collection
            if(model.collection && model.collection.type){
                model.attributes.type = model.collection.type;
                if(collection && collection.add){
                    collection = model.collection;
                }
            }

            if(!cart && collection && collection.cart){
                // utilise le panier de la collection si pas de panier
                cart = collection.cart;
            }

            // ObjectModel constructor heritage
            ObjectModel.prototype.initialize.apply(this,arguments);
            //
            //
            var id_product = model.get('id_product');

            if(model.get('id_order_detail')){
                // si on est sur une conversion Order detail > CartProductModel
                model.setupFromOrderProduct();
            }else if(model.getType() == 'extraPrice'){
                model.setupExtraPrice();
            }else if(!model.get('id_cart_product') && id_product){
                // si il n'y a pas d'id_cart_product
                model.setupFromProduct(id_product,cart);
            }else if(!id_product){
            }
            //model.set({quantitySync:model.getQuantity()});
            model.unset('cart');
            delete model.attributes.cart;


            model.on('remove',model.onRemove,model);
            //

        },
        isEditable:function () {
            var model = this,
                isOfferedProduct = model.get('id_cart_discount');
            //return !(isOfferedProduct && isOfferedProduct != 0);
            return true;
        },
        isQuantifiable:function(){
            // produit supportant la modification de quantité, autre que 1
            // donc non formule, non produit offert
            var model = this;
            return !model.isMenu() && !model.isFree();
        },
        isMenu:function (ignoreSidedish){
            return this.getProduct().isMenu(ignoreSidedish);
        },
        isSync:function(){return this.get('sync')},
        setupFromProduct:function(id_product,cart){
            // on le génère client side
            // c'est le cas pour l'ajout d'un nouveau produit
            var model = this,
                id_cart_product = id_product,
                product = app.getProduct(id_product),
                quantity = model.getQuantity(),
                options = {id_cart_product: id_cart_product};

            try {
                var price_ttc = product.getPrice('ttc', true, cart),
                    total_price_ht = product.getPrice('ht', true, cart) * quantity,
                    total_price_ttc = price_ttc * quantity;
                options = _(_(options).extend(model.pick('price_ttc','total_price_ht','total_price_ttc'))).defaults({
                        price_ttc:price_ttc,
                        total_price_ht: total_price_ht,
                        total_price_ttc: total_price_ttc
                    });
                //
                //

                if (product.isMenu()) {
                    //
                    // gestion des identifiants en XXX-n
                    //
                    var n = 0, id_test, available = false, collection = cart.getProducts();
                    while (!available) {
                        n++;
                        var unavailable = false;
                        id_test = product.id + '-' + n;
                        collection.each(function (p) {
                            if (p.id == id_test) {
                                unavailable = true;
                            }
                        });
                        available = !unavailable;
                    }
                    options.id_cart_product = id_test;
                    //
                    // gestion de la conversion "sidedish" en "accompagnements"
                    // un petit peu bullshit, mais bon...
                    //
                    var sidedish = model.get('sidedish'), productSidedishes = product.getSidedishes(), accompagnements = [];
                    //
                    /*
                    productSidedishes.each(function(sidedish){
                    });
                    /* /*/
                    _(sidedish).each(function (id_product_sidedish, id_cross_selling) {
                        _(id_product_sidedish).each(function (id_product) {
                            var productSidedish = productSidedishes.findWhere({id_cross_selling: id_cross_selling}), accompagnement = new CartProductModel({
                                id_product: id_product,
                                quantity: 1,
                                cart: cart
                            });
                            //
                            accompagnements.push(accompagnement.pick("id_product", "price_ttc", "quantity", "total_price_ht", "total_price_ttc"));
                            //
                            if (!productSidedish.isFree()) {
                                // si le produit n'est pas gratuit, on ajoute le prix à la formule
                                total_price_ttc += accompagnement.getPrice('ttc', true, cart);
                            }
                        });
                        //
                    })
                    /**/
                    options.total_price_ttc = total_price_ttc;
                    options.accompagnements = accompagnements;
                }
            }catch(err){
                // gestion d'erreur si le produit n'existe pas ou comporte un problème
                options = _(options).extend({
                    type: 'unavailable_products',
                    total_price_ht: NaN,
                    total_price_ttc: NaN
                });
            }
            model.set(options);
        },
        setupFromOrderProduct:function(){
            // converti un order detail en CartProductModel
            var model = this,
                options = {
                    type:'order',
                    id_cart_product:model.get('id_order_detail'),
                    name:model.get('product_name')
                };
            model.set(options);
        },
        setupExtraPrice:function(){
            //
            //
            // transformation d'un prix supplémentaire en produit
            //
            var model = this,
                args = this.toJSON();
            model.productExtraPrice = new ProductModel(args);
            model.set({
                id_cart_product:'extraPrice_'+model.cid,
                quantity:false,
                total_price_ttc:model.get('price_ttc'),
                total_price_ht:model.get('price_ht'),
            });
        },
        getType:function(){
            return this.get('type');
        },
        isProductLikeOffered:function () {
            return this.id === app.getCart().getProductOffered();

        },
        getProduct:function(){
            var model = this, p, id_product, type = model.getType();
            switch(type){
                // transformation d'un prix supplémentaiC en produit
                case 'extraPrice' :
                    p = model.productExtraPrice;
                    break;
                default :
                    id_product = model.get('id_product');
                    p = app.getProduct(id_product);
            }
            if(!p && type == 'order'){
                // créé un produit virtuel temporaire "deleted" à partir des infos de l'historique de commande
                p = model.p;
                if(!p) p = model.p = new ProductModel(_.extend(model.toJSON(),{deleted:true}));
            }
            return p;
        },
        editableQuantity:function(){
            // retourne si le produit est modifiable en quantité
            var model = this,
                type = model.getType();
            if (type == 'unavailable_products' || type == 'order' || model.getProduct().get('is_menu')) {
                return false; // si le produit est déjà commandé, on ne peut pas modifier la quantité
            }else{
                // si le produit a une quantité,
                return model.getQuantity() > 0;
            }
        },
        deletable:function(){return true},
        isCartProduct:function(){return true;},
        isDeleted:function(){return this.get('deleted')},
        getQuantity:function(){
            var model = this;
            return parseInt(model.get('quantity'));
        },
        getPictureUrl:function(){
            return this.getProduct().getPictureUrl('line');
        },
        displayQuantity:function(){
            var product = this,
                q = product.getQuantity() || 0;
            return((q > 0) && product.isAvailable()) ? q+'x' : app.t('Indisponible','Product');
        },
        isFixedRecipe:function(){
            var p = this.getProduct();
            return !!(p && p.isFixedRecipe());
        },
        // getWebappsActionUrl:function(action,option){
        //     var options = {
        //         action:action,
        //         id_product:this.id,
        //         option:option
        //     }
        //     return UrlFactory.getUrl('webapps-action-product',options,false,true);
        // },
        // Ajout au panier instantané
        //getQuantity:function(sync){
        //    var model = this;
        //    //return model.isDeleted() ? 0 :
        //    return model.get('quantity'+(sync ? 'Sync':''));
        //},
        //addQuantitySync:function(q){
        //    // cette fonction sert à modifier la quantité de manière synchrone
        //    // q représente une différence et non une valeur
        //    var cartProduct = this;
        //    cartProduct.setQuantitySync(cartProduct.getQuantity(true)+q);
        //},
        //deleteSync:function(){
        //    // cette fonction supprime un produit de manière synchrone
        //    var cartProduct = this;
        //    cartProduct.set({
        //        sync:false,
        //        deleted:true,
        //        total_price_ht:0,
        //        total_price_ttc:0,
        //        price_ttc:0,
        //        quantity:0,
        //        quantitySync:0,
        //    });
        //    cartProduct.trigger('delete',cartProduct);
        //    //cartProduct.collection.trigger('remove',cartProduct);
        //},
        //setQuantitySync:function(q){
        //    // cette fonction sert à setter la quantité de manière synchrone
        //    var cartProduct = this,
        //        cart = cartProduct.getCart(),
        //        product = cartProduct.getProduct(),
        //        price_ttc = product.getPrice('ttc',true,cart),
        //        total_price_ttc = q*price_ttc,
        //        total_price_ht = q*product.getPrice('ht',true,cart);
        //    //
        //    if(q == 0){
        //        // si la quantité est nulle, on supprime le produit
        //        return cartProduct.deleteSync();
        //    }
        //    //
        //    cartProduct.set({
        //        quantity:q,
        //        quantitySync:q,
        //        deleted:false,
        //        total_price_ttc:total_price_ttc,
        //        total_price_ht:total_price_ht,
        //        price_ttc:price_ttc
        //    });
        //    cartProduct.set('sync',false);
        //},
        //onChangeQuantity:function(model,quantity,status){
        //
        //    if(!model.isSync()){
        //        // si le model n'est pas synchronisé
        //        var quantitySync = model.getQuantity(true);
        //        // si la quantité est différente, entre la version synchronisée et la version cible,
        //        // on concerve la version cible
        //        if(quantitySync!=quantity){
        //            model.setQuantitySync(quantitySync,false);
        //        }else{
        //            // sinon on déclare le model comme synchronisé
        //            model.set('sync',true);
        //        }
        //    }
        //
        //},
        //onRestore:function(model,deleted){
        //    if(!deleted){
        //        model.collection.trigger('restore',model);
        //    }
        //},
        isAvailable: function () {
            return this.getType() != 'unavailable_products';
        },
        onRemove:function(model){
        },
        getPrice:function(type){
            if(_.isUndefined(type)) type = 'total_price_ttc';
            return parseFloat(this.get(type));
        },
        isFree:function(){
            var model = this;
            return model.getPrice() === 0;
        },
        getExtraClass:function(){
            var model = this, product = model.getProduct(), classes = '';
            if(!!product){
                classes =  product.getExtraClass();
            }
            if(model.isProductLikeOffered()){
                classes += ' product-like-offered'
            }
            return classes;
        },
        formatPriceQuantity:function(q,type){
            var model = this,
                quantity = model.getQuantity(),
                price = model.getPrice(type),
                unitPrice = q*price/quantity;
            return formatPrice(unitPrice);
        },
        formatPrice:function(type){
            var model = this, price;
            if(model.getType()=='extraPrice' && (model.get('free') == true)){
                // utilisé initialement pour les frais de gestion offerts
                return model.get('freeLabel');
            }else if(model.isProductLikeOffered()){
                return app.t('Offert','Product');
            }
            price = model.getPrice(type);
            /*if(price === 0){
                return app.t('Offert','Cart');
            }*/
            return formatPrice(price);
        },
        formatNameWithPrice:function(){
            // affiche le nom avec le prix, si il n'est pas gratuit
            var model = this,
                n = model.getName(),p = model.getPrice();
            if(p>0){
                n += ' '+app.t('(+ %s)','Cart',formatPrice(model.getPrice(),{auto_round_decimal:true}));
            }
            return n;
        },
        getCart:function(){
            return this.collection.cart;
        },
        getAccompagnement: function () {

            var model= this,
                accompagnements = model.accompagnements;

            // si la collection n'existe pas encore
            if(accompagnements) return accompagnements;

            var cart = model.getCart();
            // instancie les accompagnements en tant que collection
            accompagnements = new CartProductModel.CartProductCollection();
            accompagnements.attachCart(cart,'accompagnements',model);
            //
            return model.accompagnements = accompagnements;

        },
        formatAccompagnements: function(wrapper){
            // retourne le label des accompagnement,
            // permet de wrapper ceux-ci dans un template wrapper, via sprintf
            //
            var output = '', cartProduct = this, product = cartProduct.getProduct();
            if(!wrapper){
                wrapper = '<span class="%s" title="%s"> %s</span>'; // default html wrapping
            }
            cartProduct.getAccompagnement().each(function(accompagnement,index){
                var accompagnementText = accompagnement.formatNameWithPrice(),
                    classlist=['accompagnement'],
                    title=accompagnementText,
                    quantity = accompagnement.getQuantity();
                if(!accompagnement.get('visible')){
                    classlist.push('unavailable');
                    title = app.t('Produit indisponible','Product')+' : '+accompagnementText;
                }
                if(quantity>1){
                    accompagnementText = quantity+'x '+accompagnementText;
                }
                accompagnement.getExtraDisplayPrice().each(function(extraPrice){
                    accompagnementText += app.t("avec %s %s", 'cart', [extraPrice.name, product.formatPriceValue(extraPrice.price_ttc)]);
                });
                output += sprintf.sprintf(wrapper,classlist.join(' '),title,accompagnementText);
            });
            return output;
        },
        formatPriceValue: function (value)
        {
            return formatPrice(value);
        },
        getExtraDisplayPrice:function()
        {
            var model = this,
                product = model.getProduct(),
                extraDisplayPrice = !!product ? product.getExtraDisplayPrice() : _([]);

            return extraDisplayPrice;
        },
        getSidedishes: function(){
            //
            // retourne tous les accompagnements (même non affectés)
            // et défini les selections
            //
            var model = this,
                accompagnements = model.getAccompagnement(),
                sidedishes = model.getProduct().resetSidedishes(accompagnements);
            return sidedishes;
            /*
            mapped.each(function(sidedish){
                 var selection = [];
                sidedish.getCategoryProducts().each(function(product){
                    accompagnements.each(function(a){
                        if(a.id == product.id){
                            var quantity = a.get('quantity');
                            if(quantity > 1) {
                                selection.push({
                                    id: a.id,
                                    p: product,
                                    quantity: quantity,
                                    default: 0, // todo
                                    immutable: 0, // todo
                                    positions: [],
                                });
                            } else {
                                selection.push(a.id);
                            }
                        }
                    });
                });
                sidedish.set('selection',selection);
            })
            if(mapped.size()>0){
            }
            return mapped;
            */
        },
        getSidedish:function(id){
            return this.getSidedishes().findWhere({id_cross_selling:id})
        },
        isBuyableInContext:function(){
            var product = this.getProduct();
            return !!product && product.isBuyableInContext();
        },
        getName:function(){
            try{
                return this.getProduct().getName()
            }catch(err){
                app.error('Produit Indisponible',{id_cart_product:this.id})
                return app.t('Produit Indisponible','Product');
            }
        }
    };

    var CartProductModel = ObjectModel
        //.extend(LocalStorage)
        .extend(CartProductModelPrototype);

    return CartProductModel;
});
